(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mika-exe"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.getElementById('mika-exe');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = (selector) => root.querySelector(selector);
    const panels = [...root.querySelectorAll('[data-panel]')];
    const questions = [
      { title:'¿En qué universo estás viviendo hoy?', subtitle:'La primera respuesta que te dé tu cerebro. Si es que está conectado.', answers:['Uno donde soy protagonista y nadie me avisó.','En el de Bad Bunny, obviamente.','En un anime, pero soy el problema.'], reactions:['MAIN CHARACTER SYNDROME: CONFIRMADO.','PERREO INTERDIMENSIONAL: ACTIVADO.','VILLAN ARC: UNLOCKED.'] },
      { title:'Si la realidad se buguea, ¿qué activas?', subtitle:'Advertencia: ninguna opción ha sido aprobada por un adulto responsable.', answers:['Perreo de emergencia.','Un arco de entrenamiento con Jiraiya.','Cerrar sesión de la realidad por 24 horas.'], reactions:['BOOTY.EXE HA RESTAURADO EL SISTEMA.','SENSEI DETECTADO. CHAKRA: CUESTIONABLE.','MODO FANTASMA HABILITADO.'] },
      { title:'Tu estabilidad emocional actual:', subtitle:'El sistema promete no juzgar. Mucho.', answers:['100%. (Mentí).','Soy un personaje secundario con problemas de protagonista.','No sé, pero hoy me veo increíble.'], reactions:['MENTIRA DETECTADA. CONTINUANDO.','EL GUIÓN NECESITA TERAPIA.','PRIORIDADES ESTÉTICAS: CORRECTAS.'] },
      { title:'Elige tu uniforme para escapar del glitch.', subtitle:'Una decisión de alto riesgo fashion.', answers:['Oversize. Que parezca que robé ropa de otro universo.','Cómoda, pero sin perder la dignidad.','Depende de mi personalidad de ese día.'], reactions:['SILUETA OVERSIZE: APROBADA.','FIT EQUILIBRADO: SELECTED.','PERSONALIDADES MÚLTIPLES: SOPORTADAS.'] },
      { title:'Última verificación: tu talla.', subtitle:'Ni siquiera el multiverso puede adivinar esto.', answers:['XS','S','M','L','XL','2XL'], reactions:['SIZE LOCKED.','SIZE LOCKED.','SIZE LOCKED.','SIZE LOCKED.','SIZE LOCKED.','SIZE LOCKED.'] }
    ];
    let step = -1;
    let busy = false;
    let answers = [];
    const storageKey = 'nexo_mika_exe_v1';
    const show = (name) => {
      panels.forEach(panel => { panel.hidden = panel.dataset.panel !== name; });
      const label = name === 'intro' ? 'AWAITING INPUT' : name === 'reward' ? 'UNLOCKED' : name === 'loading' ? 'PROCESSING' : 'ANALYZING';
      $('#mika-stage-label').textContent = label;
      $('#mika-stage-count').textContent = String(Math.max(0,Math.min(5,step + 1))).padStart(2,'0') + ' / 05';
      $('#mika-progress-fill').style.width = (name === 'reward' ? 100 : Math.max(0,step + 1)*20) + '%';
      $('.mika__progress').setAttribute('aria-valuenow', name === 'reward' ? '5' : String(Math.max(0,step+1)));
    };
    const showQuestion = (index) => {
      step = index;
      busy = false;
      const question = questions[index];
      $('#mika-question-eyebrow').textContent = 'SYSTEM QUESTION 0' + (index+1) + ' / 05';
      $('#mika-question-title').textContent = question.title;
      $('#mika-question-subtitle').textContent = question.subtitle;
      $('#mika-reaction').textContent = '';
      const choices = $('#mika-choices');
      choices.replaceChildren();
      question.answers.forEach((answer,i) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-pressed', answers[index] === answer ? 'true' : 'false');
        const idx = document.createElement('span');
        idx.className = 'mika__choice-index';
        idx.textContent = String(i+1).padStart(2,'0');
        const copy = document.createElement('span');
        copy.className = 'mika__choice-text';
        copy.textContent = answer;
        const arrow = document.createElement('span');
        arrow.className = 'mika__choice-arrow';
        arrow.textContent = '↗';
        button.append(idx,copy,arrow);
        button.addEventListener('click',() => selectAnswer(i,button));
        choices.append(button);
      });
      show('question');
    };
    const saveLocal = (phase) => {
      try { sessionStorage.setItem(storageKey,JSON.stringify({answers,step,phase:phase || 'question',at:Date.now()})); } catch (error) {}
    };
    const loadLocal = () => {
      try { return JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (error) { return null; }
    };
    const showReward = () => {
      const size = answers[4] || '—';
      $('#mika-selected-size').textContent = 'SIZE: ' + size;
      show('reward');
      saveLocal('reward');
      window.scrollTo({top:0,behavior:'smooth'});
    };
    const prepareSubmission = () => {
      const summary = ['MIKA.EXE — MISIÓN COMPLETADA','',...questions.map((q,i)=>`${i+1}. ${q.title}\n${answers[i] || 'Sin respuesta'}`),'','TALLA CONFIRMADA: '+(answers[4] || 'N/D'),'','Regalo: Hoodie Jiraiya × Hora de Aventura','Registro privado, no comercial.'].join('\n');
      $('#mika-result-body').value = summary;
      saveLocal('reward');
    };
    const selectAnswer = (i,button) => {
      if (busy) return;
      busy = true;
      const question = questions[step];
      answers[step] = question.answers[i];
      root.querySelectorAll('.mika__choices button').forEach(el=>el.setAttribute('aria-pressed',el===button?'true':'false'));
      $('#mika-reaction').textContent = '> ' + question.reactions[i];
      saveLocal();
      setTimeout(() => {
        if (step < 4) { showQuestion(step+1); return; }
        show('loading');
        $('#mika-loading-copy').textContent = 'DR. DOCTOR HA REVISADO TUS RESPUESTAS...';
        setTimeout(() => {
          $('#mika-loading-copy').textContent = 'CASO IRREVERSIBLE. ASIGNANDO RECOMPENSA...';
          prepareSubmission();
          showReward();
        },1650);
      },650);
    };
    $('#mika-start').addEventListener('click',() => showQuestion(0));
    $('#mika-back').addEventListener('click',() => { if (busy) return; if (step === 0) { step=-1; show('intro'); } else showQuestion(step-1); });
    $('#mika-claim').addEventListener('click',() => prepareSubmission());
    root.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click',() => {
      const view = button.dataset.view;
      root.querySelectorAll('[data-view]').forEach(el => el.setAttribute('aria-pressed',String(el===button)));
      $('#mika-product-back').classList.toggle('is-active',view==='back');
      $('#mika-product-front').classList.toggle('is-active',view==='front');
    }));
    $('#mika-replay').addEventListener('click',() => { step=-1; busy=false; answers=[]; try { sessionStorage.removeItem(storageKey); } catch (error) {} show('intro'); window.scrollTo({top:0,behavior:'smooth'}); });
    const prior = loadLocal();
    if (prior && Array.isArray(prior.answers)) answers = prior.answers;
    const wasSaved = Boolean($('[data-mika-saved]'));
    const hadError = Boolean($('[data-mika-error]'));
    if (wasSaved || hadError || (prior && prior.phase === 'reward' && answers[4])) {
      step=4;
      showReward();
      if (wasSaved) {
        $('#mika-claim-status').textContent = 'TALLA REGISTRADA. MISIÓN COMPLETA ✓';
        $('#mika-claim-hint').textContent = 'Tu regalo ya tiene una talla asignada en el sistema.';
        $('#mika-claim').hidden = true;
      } else if (hadError) {
        $('#mika-claim-status').textContent = 'NO PUDIMOS REGISTRAR LA TALLA.';
        $('#mika-claim-hint').textContent = 'Tu recompensa está desbloqueada. Intenta confirmar tu talla de nuevo.';
      }
    } else show('intro');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nxo-reviews"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('nxo-review-gallery')) {
    customElements.define('nxo-review-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.reviewReady) return;
        this.reviewReady = true;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('[data-nxo-review-track]');
        if (!this.track) return;
        this.mobile = matchMedia('(max-width: 749px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.limit = Math.max(2, Math.min(12, Number(this.dataset.reviewLimit) || 8));
        this.visibleCount = this.limit;
        this.cards = [...this.track.querySelectorAll('[data-nxo-review-id]')];
        this.photoDialog = this.querySelector('.nxo-reviews__lightbox');
        this.fullPhoto = this.querySelector('[data-nxo-review-full-photo]');
        this.textDialog = this.querySelector('.nxo-reviews__full-review');
        this.more = this.querySelector('[data-nxo-review-more]');
        this.controls = this.querySelector('[data-nxo-review-controls]');
        this.previous = this.querySelector('[data-nxo-review-previous]');
        this.next = this.querySelector('[data-nxo-review-next]');
        this.addEventListener('click', event => {
          const photo = event.target.closest('[data-nxo-review-photo]');
          if (photo && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && typeof this.photoDialog?.showModal === 'function') {
            event.preventDefault();
            this.photoLinks = [...photo.closest('article').querySelectorAll('[data-nxo-review-photo]')];
            this.photoIndex = this.photoLinks.indexOf(photo);
            this.showPhoto(); this.photoDialog.showModal();
          }
          const read = event.target.closest('[data-nxo-review-read]');
          if (read && typeof this.textDialog?.showModal === 'function') {
            const card = read.closest('article');
            const content = this.textDialog.querySelector('[data-nxo-review-full-content]');
            content.replaceChildren(...['.nxo-reviews__meta','[data-nxo-review-content]','.nxo-reviews__author'].map(selector => card.querySelector(selector).cloneNode(true)));
            this.textDialog.showModal();
          }
        }, {signal});
        for (const [dialog, selector] of [[this.photoDialog,'[data-nxo-review-close]'],[this.textDialog,'[data-nxo-text-close]']]) {
          if (!dialog) continue;
          dialog.querySelector(selector).addEventListener('click', () => dialog.close(), {signal});
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const box = dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
          }, {signal});
        }
        this.photoDialog?.addEventListener('close', () => this.fullPhoto.removeAttribute('src'), {signal});
        this.textDialog?.addEventListener('close', () => this.textDialog.querySelector('[data-nxo-review-full-content]').replaceChildren(), {signal});
        this.querySelector('[data-nxo-photo-previous]')?.addEventListener('click', () => this.stepPhoto(-1), {signal});
        this.querySelector('[data-nxo-photo-next]')?.addEventListener('click', () => this.stepPhoto(1), {signal});
        this.photoDialog?.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault(); this.stepPhoto(event.key === 'ArrowLeft' ? -1 : 1);
        }, {signal});
        this.more.addEventListener('click', () => { this.visibleCount += this.limit; this.layout(); }, {signal});
        this.previous.addEventListener('click', () => this.stepReview(-1), {signal});
        this.next.addEventListener('click', () => this.stepReview(1), {signal});
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !this.mobile.matches) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault(); this.stepReview(event.key === 'ArrowLeft' ? -1 : 1);
        }, {signal});
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.updateControls(); });
        }, {passive:true,signal});
        this.mobile.addEventListener('change', () => this.layout(), {signal});
        this.observer = new ResizeObserver(() => { this.measureText(); this.updateControls(); });
        this.observer.observe(this.track);
        this.collectPages(signal).then(() => {
          if (!this.isConnected || signal.aborted) return;
          this.classList.add('is-enhanced');
          this.layout();
          this.querySelector('[data-nxo-review-pagination]')?.setAttribute('hidden','');
        }).catch(() => {
          if (!signal.aborted) { this.track.removeAttribute('tabindex'); this.controls.hidden = true; }
        });
      }
      async collectPages(signal) {
        const queue = [...this.querySelectorAll('[data-nxo-review-pagination] a')].map(link => link.href);
        const visited = new Set();
        const key = card => card.dataset.nxoReviewId || 'position:'+card.dataset.nxoReviewPosition;
        const byId = new Map(this.cards.map(card => [key(card),card]));
        while (queue.length) {
          const url = new URL(queue.shift(), location.href);
          if (url.origin !== location.origin || url.pathname !== location.pathname) throw Error('Unexpected review location');
          url.hash = '';
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id',preview);
          url.searchParams.set('section_id',this.dataset.sectionId);
          if (visited.has(url.href)) continue;
          if (visited.size >= 12) throw Error('Review page limit');
          visited.add(url.href);
          const response = await fetch(url,{credentials:'same-origin',signal});
          if (!response.ok) throw Error('Reviews unavailable');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const gallery = [...doc.querySelectorAll('nxo-review-gallery')].find(node => node.dataset.sectionId === this.dataset.sectionId);
          if (!gallery) throw Error('Review section unavailable');
          for (const card of gallery.querySelectorAll('[data-nxo-review-id]')) if (!byId.has(key(card))) byId.set(key(card),card);
          for (const link of gallery.querySelectorAll('[data-nxo-review-pagination] a')) queue.push(new URL(link.getAttribute('href'),url).href);
        }
        this.cards = [...byId.values()].sort((a,b) => Number(a.dataset.nxoReviewPosition)-Number(b.dataset.nxoReviewPosition));
        this.cards = [...this.cards.filter(card => card.classList.contains('nxo-reviews__card--photo')),...this.cards.filter(card => card.classList.contains('nxo-reviews__card--text'))];
        for (const group of this.track.querySelectorAll('[data-nxo-review-group]')) group.replaceChildren();
        this.cards.forEach((card,index) => {
          card.querySelector('[data-nxo-review-number]').textContent = String(index+1).padStart(3,'0');
          const kind = card.classList.contains('nxo-reviews__card--photo') ? 'photos' : 'text';
          this.track.querySelector('[data-nxo-review-group="'+kind+'"]').append(card);
        });
      }
      layout() {
        this.cards.forEach((card,index) => { card.hidden = !this.mobile.matches && index >= this.visibleCount; });
        for (const group of this.track.querySelectorAll('[data-nxo-review-group]')) group.hidden = ![...group.children].some(card => !card.hidden);
        this.more.hidden = this.mobile.matches || this.visibleCount >= this.cards.length;
        this.controls.hidden = !this.mobile.matches || this.cards.length < 2;
        this.measureText(); this.updateControls();
      }
      measureText() {
        if (!this.classList.contains('is-enhanced')) return;
        for (const card of this.cards) {
          if (card.hidden) continue;
          const body = card.querySelector('.nxo-reviews__body');
          const title = card.querySelector('h3');
          const overflow = body.scrollHeight > body.clientHeight+1 || (title && title.scrollHeight > title.clientHeight+1) || !!card.querySelector('.nxo-reviews__reply');
          card.querySelector('[data-nxo-review-read]').hidden = !overflow;
        }
      }
      stepReview(direction) {
        const visible = this.cards.filter(card => !card.hidden);
        const left = this.track.getBoundingClientRect().left;
        let index = visible.reduce((best,card,i) => Math.abs(card.getBoundingClientRect().left-left) < Math.abs(visible[best].getBoundingClientRect().left-left) ? i : best,0);
        const target = visible[Math.max(0,Math.min(visible.length-1,index+direction))];
        if (target) this.track.scrollBy({left:target.getBoundingClientRect().left-left-2,behavior:this.reducedMotion.matches?'auto':'smooth'});
      }
      updateControls() {
        if (!this.previous || !this.track) return;
        this.previous.disabled = this.track.scrollLeft <= 3;
        this.next.disabled = this.track.scrollWidth-this.track.clientWidth-this.track.scrollLeft <= 3;
      }
      showPhoto() {
        this.fullPhoto.src = this.photoLinks[this.photoIndex].href;
        this.querySelector('[data-nxo-photo-controls]').hidden = this.photoLinks.length < 2;
        this.querySelector('[data-nxo-photo-previous]').disabled = this.photoIndex === 0;
        this.querySelector('[data-nxo-photo-next]').disabled = this.photoIndex === this.photoLinks.length-1;
      }
      stepPhoto(direction) { this.photoIndex = Math.max(0,Math.min(this.photoLinks.length-1,this.photoIndex+direction)); this.showPhoto(); }
      disconnectedCallback() {
        this.abort?.abort(); this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.photoDialog?.open) this.photoDialog.close();
        if (this.textDialog?.open) this.textDialog.close();
        this.reviewReady = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
